import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { environment } from '@/environments/environment';
import { provideDsOnluyenConfig } from '@digital-school/ds-onluyen-lib';
import { AUTH_TOKEN_STORAGE_KEY } from './modules/login/services/login-api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    provideDsOnluyenConfig({
      apiUrl: environment.API_URL,
      schoolxUrl: environment.SCHOOLX,
      getToken: () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY),
      logout: () => {
        localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
        window.location.replace('/login');
      },
    }),
  ],
};
